import React from "react";
import MilestoneCountdown from "./MilestoneCountdown";

type Milestone = {
    title?: string;
    end_at?: string | null;
    color?: string;
};

type CommandMilestonesProps = {
    data?: {
        milestones?: Milestone[];
    };
    label?: string;
};

const CommandMilestones: React.FC<CommandMilestonesProps> = ({ data, label }) => {
    const milestones = data?.milestones || [];

    if (milestones.length === 0) {
        return (
            <div className="h-full w-full flex items-center justify-center font-plot-open-sans text-plot-light-grey">
                No milestones configured
            </div>
        );
    }

    return (
        <div className="w-full h-full flex flex-col gap-20 pt-[10%] pb-[15%]">
            <h1 className="font-plot-oswald text-5xl text-center uppercase tracking-widest  text-plot-white">
                {label || "Upcoming Milestones"}
            </h1>
            {milestones.map((milestone, index) => (
                <MilestoneCountdown key={index} milestone={milestone} />
            ))}
        </div>
    );
};

export default CommandMilestones;
